import { computed, ref } from 'vue'
import { fetchPersonnel, type PersonnelListItem } from '@/services/personnel'
import { formatName } from '@staff/shared'

const personnel = ref<PersonnelListItem[]>([])
const isLoadingPersonnel = ref(false)
let loadPromise: Promise<void> | null = null

const formatPersonnelName = (user: PersonnelListItem['user']) => formatName(user) ?? '-'

const getPersonnelNameByPersonnelId = (personnelId?: string | null) => {
  if (!personnelId) return '-'
  return formatPersonnelName(personnel.value.find((item) => item.id === personnelId)?.user)
}

const getPersonnelNameByUserId = (userId?: string) => {
  if (!userId) return ''
  const person = personnel.value.find((item) => item.user?.id === userId)
  return person ? formatPersonnelName(person.user) : ''
}

const getPersonnelIdByUserId = (userId?: string) => {
  if (!userId) return ''
  const person = personnel.value.find((person) => person.user?.id === userId)
  return person?.id ?? ''
}

const personnelOptions = computed(() =>
  personnel.value.map((person) => ({
    text: formatPersonnelName(person.user),
    value: person.id,
  })),
)

const loadPersonnelDirectory = async (force = false) => {
  if (!force && personnel.value.length) return
  if (loadPromise) return loadPromise

  isLoadingPersonnel.value = true
  loadPromise = (async () => {
    try {
      personnel.value = await fetchPersonnel()
    } finally {
      isLoadingPersonnel.value = false
      loadPromise = null
    }
  })()

  return loadPromise
}

export const usePersonnelDirectory = () => ({
  personnel,
  personnelOptions,
  isLoadingPersonnel,
  loadPersonnelDirectory,
  getPersonnelNameByPersonnelId,
  getPersonnelNameByUserId,
  getPersonnelIdByUserId,
})
